import { render } from "./FilterProgressao.vue?vue&type=template&id=f253da46&scoped=true"
import script from "./FilterProgressao.vue?vue&type=script&lang=js"
export * from "./FilterProgressao.vue?vue&type=script&lang=js"

import "./FilterProgressao.vue?vue&type=style&index=0&id=f253da46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f253da46"]])

export default __exports__